import styled from "styled-components";

export const StyledSignUp = styled.div`
    padding: 46px 25px 25px 25px;
    background-color: ${(p) => p.theme.colors.card};
    position: relative;
    top: -80px;
    border-radius: 12px;
    text-align: center;
    /* box-shadow: 0px 4px 10px 1px #e7e2e2; */
    min-height: calc(100vh - 200px);
    .allow-dropdown.intl-tel-input {
        width: 100% !important;
        background-color: inherit;
    }
    .intl-tel-input.allow-dropdown input[type="text"],
    .intl-tel-input.allow-dropdown input[type="tel"] {
        height: 48px !important;
        outline: none;
        border: none;
        background-color: inherit;
        width: 100% !important;
        font-size: 16px;
        color: inherit;
        box-shadow: none !important;
        font-weight: 500;
    }
`;
